import store from '../../store/index';
import { createEventosSite, calcularDesconto } from './util';
import modal from './modal';

export default {
    open() {
        store.commit("showShoppingCar", true);
    },
    close() {
        store.commit("showShoppingCar", false);
    },
    start() {
        if(localStorage.getItem("planos")) {
            const plans = JSON.parse(localStorage.getItem("planos"));
            if(plans.length > 0) {
              store.commit("setShoppingCar", plans);
              this.updateTotal_Subtotal_Adesao();
            }
        }
    },
    finish() {
        store.commit("updateShoppingCarValues", {
            display: false,
            plans: [],
            total: 0, 
            subtotal: 0, 
            adesao: 0,
            descontoAplicado: 0,
        });
        localStorage.removeItem("planos");
    },
    updateTotal_Subtotal_Adesao() {
        let total = 0;
        let subtotal = 0;
        let adesao = 0;
        let descontoAplicado = 0;

        store.getters.shoppingCar.plans.forEach(plan => {
            if (!plan.planos_vinculados || plan.planos_vinculados.length == 0) {
                total += plan.price * plan.qtd;
                adesao += plan.setup_fee * plan.qtd;

                // 1. Identifica se o plano possui plano_base (seja como objeto ou como ID numérico)
                const temPlanoBase = plan.plano_base !== null && plan.plano_base !== undefined;
                
                // 2. Extrai o valor do desconto (trata se plano_base for objeto ou se estiver direto no plano)
                const valorDescontoBase = (typeof plan.plano_base === 'object' && plan.plano_base?.valor_desconto !== undefined)
                    ? plan.plano_base.valor_desconto
                    : (plan.valor_desconto ?? 0);

                // 3. Extrai o tipo do desconto
                const tipoDescontoBase = (typeof plan.plano_base === 'object' && plan.plano_base?.tipo_desconto)
                    ? plan.plano_base.tipo_desconto
                    : (temPlanoBase ? 'abs' : null);

                const valorDescontoNaoBase = plan.valor_desconto ?? 0;
                const tipoDescontoNaoBase = plan.tipo_desconto;
                //console.log('tipb', tipoDescontoBase)
                // Calcula desconto do plano base
                if (tipoDescontoBase) {
                    descontoAplicado += calcularDesconto(plan, valorDescontoBase, tipoDescontoBase, plan.price, plan.qtd);
                }
                
                // Calcula desconto caso não seja base
                if (tipoDescontoNaoBase && !temPlanoBase) {
                    //console.log('valores', plan, valorDescontoNaoBase, tipoDescontoNaoBase, plan.price, plan.qtd)
                    descontoAplicado += calcularDesconto(plan, valorDescontoNaoBase, tipoDescontoNaoBase, plan.price, plan.qtd);
                }
                //console.log('tipo e valor desconto', plan, descontoAplicado)
            }

            if (plan.planos_vinculados && plan.planos_vinculados.length > 0) {
                plan.planos_vinculados.forEach(v => {
                    const planoV = v.plano || v;
                    total += planoV.price * (planoV.qtd || 1);
                    adesao += (planoV.setup_fee || 0) * (planoV.qtd || 1);

                    const valorDesconto = plan.valor_desconto ?? planoV.plano_base?.valor_desconto ?? planoV.valor_desconto ?? 0;
                    const tipoDesconto = plan.tipo_desconto || planoV.tipo_desconto || planoV.plano_base?.tipo_desconto;
                    
                    if (tipoDesconto) {
                        descontoAplicado += calcularDesconto(planoV, valorDesconto, tipoDesconto, planoV.price, planoV.qtd || 1);
                    }
                });
            }
        });

        subtotal = total + adesao;
        total = total - descontoAplicado;
        console.log('updateShoppingCarValues', total, subtotal, adesao, descontoAplicado);
        store.commit("updateShoppingCarValues", {
            display: store.getters.shoppingCar.display,
            plans: store.getters.shoppingCar.plans,
            total, 
            subtotal, 
            adesao,
            descontoAplicado
        });
    },
    add(plan) {
        this.open();
        createEventosSite('CLICK', 'botao_add_carinho');
        let currentPlans = store.getters.shoppingCar.plans;
        let indexPlano = currentPlans.findIndex((p) => p.id === plan.id);
        indexPlano >= 0
            ? currentPlans[indexPlano].qtd += 1
            : currentPlans.push({...plan, active: plan.active})
        if(plan.planos_vinculados){
            plan.planos_vinculados.forEach((p) => {
                p.plano.qtd = p.qtd_min;
            });
        }
        store.commit("setShoppingCar", currentPlans);
        localStorage.setItem("planos", JSON.stringify(currentPlans));
        this.updateTotal_Subtotal_Adesao();
    },
    remove(plan) {
        modal.open(
            "Atenção!",
            "Se você realizar essa ação um plano será removido do carrinho, deseja continuar?",
            "Sim",
            "Não",
            () => {
                let currentPlans = store.getters.shoppingCar.plans;
                let indexPlano = currentPlans.findIndex((p) => p.id === plan.id);
                currentPlans.splice(indexPlano, 1);
                store.commit("setShoppingCar", currentPlans);
                this.updateTotal_Subtotal_Adesao();
                localStorage.setItem("planos", JSON.stringify(currentPlans));
            },
            () => modal.close()
        );
    },
    sum(plan) {
        plan.qtd += 1;
        this.updateTotal_Subtotal_Adesao();
        localStorage.setItem("planos", JSON.stringify(store.getters.shoppingCar.plans));
    },
    sub(plan, qtd_min) {
        if(qtd_min == undefined){
            qtd_min = 1;
        }
        if (plan.qtd > qtd_min) {
            plan.qtd -= 1;
            this.updateTotal_Subtotal_Adesao();
            localStorage.setItem("planos", JSON.stringify(store.getters.shoppingCar.plans));
        } else {
            this.remove(plan);
        }
    },
}
